import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sortable"
export default class extends Controller {
  static targets = ["table", "input", "submitButton"]
  static values = { initialValue: String }
  connect() {
    this.initialValue = this.inputTarget.value;
    console.log("sortable controller connected");
    // Add drag handles to all rows in the table
    this.tableTarget.querySelectorAll('tr').forEach(row => {
      const dragHandle = document.createElement('td');
      dragHandle.innerHTML = '<i class="la la-arrows-v m--font-metal"></i>';
      row.insertBefore(dragHandle, row.firstChild);
    });
    $(this.tableTarget).sortable({
      update: (event, ui) => {
        this.initialValue = this.inputTarget.value;
        window.test = $(this.tableTarget).find('tr');
        let ids = [];
        $(this.tableTarget).find('tr').map((index, row) => {
          ids.push(row.id.split("_")[1]);
        });
        $(this.inputTarget).val(ids.join(','));

        if (ids.join(',') !== this.initialValue) {
          $(this.submitButtonTarget).show();
        } else {
          $(this.submitButtonTarget).hide();
        }
      },
    });
  }
}
